import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AnonymousUser } from '../models/authorization/anonymous-user.model';
import { EnvironmentService } from './environment.service';
import { PinCredentials } from '../models/authorization/pin-credentials';
import { HttpHelper } from '../helpers/http';
import { LocalStorageHelper } from '../helpers/local-storage';

@Injectable({ providedIn: 'root' })
export class PinAuthenticationService {
	private currentAnonUserSubject: BehaviorSubject<AnonymousUser>;
	public currentAnonUser: Observable<AnonymousUser>;

	constructor(private http: HttpClient, 
		private environmentService: EnvironmentService,
		private httpHelper: HttpHelper,
		private localStorageHelper: LocalStorageHelper) {
			this.currentAnonUserSubject = new BehaviorSubject<AnonymousUser>(this.localStorageHelper.getCurrentAnonUser());
			this.currentAnonUser = this.currentAnonUserSubject.asObservable();
	}

	private pinEndpoint: string = this.environmentService.getBaseUrl() + "/api/authentication/anonymous";

	public get currentAnonUserValue(): AnonymousUser {
		this.currentAnonUserSubject = new BehaviorSubject<AnonymousUser>(this.localStorageHelper.getCurrentAnonUser());
		return this.currentAnonUserSubject.value;
	}

	public get isAnonUserAuthenticated(): boolean {
		let currentAnonUser = this.localStorageHelper.getCurrentAnonUser();
		let currentDate = new Date();
		let currentUtcDate = new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60 * 1000);

		if (currentAnonUser === null || currentUtcDate > new Date(currentAnonUser.expiration)) {
			return false;
		}
		else {
			return true;
		}
	}

	public validatePin(pin: string) {
		let credentials = new PinCredentials();
		credentials.pin = pin;
		credentials.diaryId = this.localStorageHelper.getScannedDiaryId();

		return this.http.post<any>(this.pinEndpoint, 
			JSON.stringify(credentials),
			this.httpHelper.SetRequiredAwsHttpPostHeaders())
				.pipe(map(anonymousUser => {
					this.setPinAuthJwt(anonymousUser);
					return anonymousUser;
				}));
	}

	public setPinAuthJwt(anonymousUser: any) {
		this.localStorageHelper.setCurrentAnonUser(anonymousUser);
		this.currentAnonUserSubject.next(anonymousUser);
	}

	public removePinSession() {
		this.localStorageHelper.wipeCurrentAnonUser();
		this.currentAnonUserSubject.next(null);
	}
}
